// export const BASE_URL = 'https://lcs.dephub.go.id/api/v1/'
// export const BASE_URL = 'https://dev-barang-api.nutech-integrasi.app/v1/'
// export const BASE_URL = 'http://localhost:7022/v1/'

// export const BASE_URL = "https://tolaut.devops-nutech.com/api/v1/";
// export const BASE_URL = "http://192.168.1.123:7022/v1/";
export const BASE_URL = "https://sitolaut.dephub.go.id/api/v1/";

// export const UPLOAD_URL = 'https://dev-lcs.nutech-integrasi.app/lcs_tol_laut_api_phase_2/images/'
// export const UPLOAD_URL = '/var/www/html/tollaut/images/'
// export const UPLOAD_URL = "https://tolaut.devops-nutech.com/images/";
export const UPLOAD_URL = "https://sitolaut.dephub.go.id/uploads/";

// export const BASE_URL_SOCKET = "http://192.168.50.159:7022";
// export const BASE_URL_SOCKET = "https://tolaut.devops-nutech.com";
export const BASE_URL_SOCKET = "https://sitolaut.dephub.go.id/";

export const CONSIGNEE_PANDUAN_URL =
  "https://drive.google.com/drive/folders/1Ol_Q0H_4WS6DN2QqB925m5sLNb95i6xw";
export const SUPPLIER_PANDUAN_URL =
  "https://drive.google.com/drive/folders/1Ol_Q0H_4WS6DN2QqB925m5sLNb95i6xw";
export const SHIPPER_PANDUAN_URL =
  "https://drive.google.com/drive/folders/1Ol_Q0H_4WS6DN2QqB925m5sLNb95i6xwL";
export const OPERATOR_PANDUAN_URL =
  "https://drive.google.com/drive/folders/1Ol_Q0H_4WS6DN2QqB925m5sLNb95i6xw";
export const REGULATOR_PANDUAN_URL =
  "https://drive.google.com/drive/folders/1Ol_Q0H_4WS6DN2QqB925m5sLNb95i6xw";
export const RESELLER_PANDUAN_URL =
  "https://drive.google.com/drive/folders/1Ol_Q0H_4WS6DN2QqB925m5sLNb95i6xw";

export const SITE_KEY = "6LfoTaYZAAAAAAaY0LBNsLdnMgR8ghL-GnS_thll";
export const IS_CAPTCHA = "DISABLE";

export const ID_CONSIGNEE = 1;
export const ID_SUPPLIER = 2;
export const ID_SHIPPER = 3;
export const ID_RESELLER = 4;
export const ID_VESSEL_OP = 5;
export const ID_REGULATOR = 6;

export const FORM_CONSIGNEE = "consignee";
export const FORM_SUPPLIER = "supplier";
export const FORM_SHIPPER = "shipper";
export const FORM_RESELLER = "reseller";
export const FORM_VESSEL_OP = "operator";
export const FORM_REGULATOR = "regulator";

export const ID_BARANG_POKOK = 1;
export const ID_BARANG_PENTING = 2;
export const ID_BARANG_PENTING_LAINNYA = 3;
export const ID_BARANG_PENTING_PEMDA = 4;
export const ID_BARANG_KOMERSIL = 5;

export const STATUS_USER_KONFIRMASI = 0;
export const STATUS_USER_TERIMA = 1;
export const STATUS_USER_TOLAK = 2;

// Max upload
export const MAX_UPLOAD = "512KB";

// Auth
export const AUTH_LOGIN_URL = "login";
export const AUTH_LOGIN_ERROR = "AUTH_LOGIN_ERROR";
export const AUTH_LOGIN_LOADING = "AUTH_LOGIN_LOADING";
export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";

export const AUTH_LOGOUT_LOADING = "AUTH_LOGOUT_LOADING";
export const AUTH_LOGOUT_SUCCESS = "AUTH_LOGOUT_SUCCESS";

export const AUTH_REGISTER_URL = "register";
export const AUTH_REGISTER_ERROR = "AUTH_REGISTER_ERROR";
export const AUTH_REGISTER_LOADING = "AUTH_REGISTER_LOADING";
export const AUTH_REGISTER_SUCCESS = "AUTH_REGISTER_SUCCESS";

export const AUTH_REGISTER_CHECK_URL = "register/check";
export const AUTH_REGISTER_CHECK_ERROR = "AUTH_REGISTER_CHECK_ERROR";
export const AUTH_REGISTER_CHECK_LOADING = "AUTH_REGISTER_CHECK_LOADING";
export const AUTH_REGISTER_CHECK_SUCCESS = "AUTH_REGISTER_CHECK_SUCCESS";

// Forgot Password
export const FORGOT_PASSWORD_URL = "forgot-password";
export const FORGOT_PASSWORD_ERROR = "FORGOT_PASSWORD_ERROR";
export const FORGOT_PASSWORD_LOADING = "FORGOT_PASSWORD_LOADING";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";

export const RESET_PASSWORD_URL = "reset-password";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";
export const RESET_PASSWORD_LOADING = "RESET_PASSWORD_LOADING";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";

// User
export const USER_URL = "user";
export const REGULATOR_URL = "regulator";

export const USER_GET_ERROR = "USER_HAS_ERROR";
export const USER_GET_LOADING = "USER_IS_LOADING";
export const USER_GET_SUCCESS = "USER_IS_SUCCESS";

export const USER_VIEW_ERROR = "USER_VIEW_ERROR";
export const USER_VIEW_LOADING = "USER_VIEW_LOADING";
export const USER_VIEW_SUCCESS = "USER_VIEW_SUCCESS";

export const USER_ADD_ERROR = "USER_ADD_ERROR";
export const USER_ADD_LOADING = "USER_ADD_LOADING";
export const USER_ADD_SUCCESS = "USER_ADD_SUCCESS";

export const USER_DELETE_ERROR = "USER_DELETE_ERROR";
export const USER_DELETE_LOADING = "USER_DELETE_LOADING";
export const USER_DELETE_SUCCESS = "USER_DELETE_SUCCESS";

// Purchase
export const PURCHASE_URL = "purchaseorder";
export const PURCHASE_CONSIGNEE_URL = "purchaseorder/cek_po_consignee";

export const PURCHASE_GET_ERROR = "PURCHASE_HAS_ERROR";
export const PURCHASE_GET_LOADING = "PURCHASE_IS_LOADING";
export const PURCHASE_GET_SUCCESS = "PURCHASE_IS_SUCCESS";

export const PURCHASE_VIEW_ERROR = "PURCHASE_VIEW_ERROR";
export const PURCHASE_VIEW_LOADING = "PURCHASE_VIEW_LOADING";
export const PURCHASE_VIEW_SUCCESS = "PURCHASE_VIEW_SUCCESS";

export const PURCHASE_ADD_ERROR = "PURCHASE_ADD_ERROR";
export const PURCHASE_ADD_LOADING = "PURCHASE_ADD_LOADING";
export const PURCHASE_ADD_SUCCESS = "PURCHASE_ADD_SUCCESS";

export const PURCHASE_DELETE_ERROR = "PURCHASE_DELETE_ERROR";
export const PURCHASE_DELETE_LOADING = "PURCHASE_DELETE_LOADING";
export const PURCHASE_DELETE_SUCCESS = "PURCHASE_DELETE_SUCCESS";
export const PURCHASE_CANCEL = "PURCHASE_CANCEL";

// Detailpo
export const DETAILPO_URL = "detailpo";

export const DETAILPO_GET_ERROR = "DETAILPO_HAS_ERROR";
export const DETAILPO_GET_LOADING = "DETAILPO_IS_LOADING";
export const DETAILPO_GET_SUCCESS = "DETAILPO_IS_SUCCESS";

export const DETAILPO_VIEW_ERROR = "DETAILPO_VIEW_ERROR";
export const DETAILPO_VIEW_LOADING = "DETAILPO_VIEW_LOADING";
export const DETAILPO_VIEW_SUCCESS = "DETAILPO_VIEW_SUCCESS";

export const DETAILPO_ADD_ERROR = "DETAILPO_ADD_ERROR";
export const DETAILPO_ADD_LOADING = "DETAILPO_ADD_LOADING";
export const DETAILPO_ADD_SUCCESS = "DETAILPO_ADD_SUCCESS";

export const DETAILPO_DELETE_ERROR = "DETAILPO_DELETE_ERROR";
export const DETAILPO_DELETE_LOADING = "DETAILPO_DELETE_LOADING";
export const DETAILPO_DELETE_SUCCESS = "DETAILPO_DELETE_SUCCESS";

// Consignee
export const CONSIGNEE_URL = "consignee";

export const CONSIGNEE_GET_ERROR = "CONSIGNEE_HAS_ERROR";
export const CONSIGNEE_GET_LOADING = "CONSIGNEE_IS_LOADING";
export const CONSIGNEE_GET_SUCCESS = "CONSIGNEE_IS_SUCCESS";

export const CONSIGNEE_VIEW_ERROR = "CONSIGNEE_VIEW_ERROR";
export const CONSIGNEE_VIEW_LOADING = "CONSIGNEE_VIEW_LOADING";
export const CONSIGNEE_VIEW_SUCCESS = "CONSIGNEE_VIEW_SUCCESS";

export const CONSIGNEE_ADD_ERROR = "CONSIGNEE_ADD_ERROR";
export const CONSIGNEE_ADD_LOADING = "CONSIGNEE_ADD_LOADING";
export const CONSIGNEE_ADD_INVALID = "CONSIGNEE_ADD_INVALID";
export const CONSIGNEE_ADD_SUCCESS = "CONSIGNEE_ADD_SUCCESS";

export const CONSIGNEE_DELETE_ERROR = "CONSIGNEE_DELETE_ERROR";
export const CONSIGNEE_DELETE_LOADING = "CONSIGNEE_DELETE_LOADING";
export const CONSIGNEE_DELETE_SUCCESS = "CONSIGNEE_DELETE_SUCCESS";

// Supplier
export const SUPPLIER_URL = "supplier";

export const SUPPLIER_GET_ERROR = "SUPPLIER_HAS_ERROR";
export const SUPPLIER_GET_LOADING = "SUPPLIER_IS_LOADING";
export const SUPPLIER_GET_SUCCESS = "SUPPLIER_IS_SUCCESS";

export const SUPPLIER_VIEW_ERROR = "SUPPLIER_VIEW_ERROR";
export const SUPPLIER_VIEW_LOADING = "SUPPLIER_VIEW_LOADING";
export const SUPPLIER_VIEW_SUCCESS = "SUPPLIER_VIEW_SUCCESS";

export const SUPPLIER_ADD_ERROR = "SUPPLIER_ADD_ERROR";
export const SUPPLIER_ADD_LOADING = "SUPPLIER_ADD_LOADING";
export const SUPPLIER_ADD_INVALID = "SUPPLIER_ADD_INVALID";
export const SUPPLIER_ADD_SUCCESS = "SUPPLIER_ADD_SUCCESS";

export const SUPPLIER_DELETE_ERROR = "SUPPLIER_DELETE_ERROR";
export const SUPPLIER_DELETE_LOADING = "SUPPLIER_DELETE_LOADING";
export const SUPPLIER_DELETE_SUCCESS = "SUPPLIER_DELETE_SUCCESS";

// Shipper
export const SHIPPER_URL = "shipper";
export const SHIPPER_PRICE_URL = "get_biaya_pengurusan";

export const SHIPPER_GET_ERROR = "SHIPPER_HAS_ERROR";
export const SHIPPER_GET_LOADING = "SHIPPER_IS_LOADING";
export const SHIPPER_GET_SUCCESS = "SHIPPER_IS_SUCCESS";

export const SHIPPER_VIEW_ERROR = "SHIPPER_VIEW_ERROR";
export const SHIPPER_VIEW_LOADING = "SHIPPER_VIEW_LOADING";
export const SHIPPER_VIEW_SUCCESS = "SHIPPER_VIEW_SUCCESS";

export const SHIPPER_ADD_ERROR = "SHIPPER_ADD_ERROR";
export const SHIPPER_ADD_LOADING = "SHIPPER_ADD_LOADING";
export const SHIPPER_ADD_INVALID = "SHIPPER_ADD_INVALID";
export const SHIPPER_ADD_SUCCESS = "SHIPPER_ADD_SUCCESS";

export const SHIPPER_DELETE_ERROR = "SHIPPER_DELETE_ERROR";
export const SHIPPER_DELETE_LOADING = "SHIPPER_DELETE_LOADING";
export const SHIPPER_DELETE_SUCCESS = "SHIPPER_DELETE_SUCCESS";

// Operator
export const OPERATOR_URL = "operator";

export const OPERATOR_GET_ERROR = "OPERATOR_HAS_ERROR";
export const OPERATOR_GET_LOADING = "OPERATOR_IS_LOADING";
export const OPERATOR_GET_SUCCESS = "OPERATOR_IS_SUCCESS";

export const OPERATOR_VIEW_ERROR = "OPERATOR_VIEW_ERROR";
export const OPERATOR_VIEW_LOADING = "OPERATOR_VIEW_LOADING";
export const OPERATOR_VIEW_SUCCESS = "OPERATOR_VIEW_SUCCESS";

export const OPERATOR_ADD_ERROR = "OPERATOR_ADD_ERROR";
export const OPERATOR_ADD_LOADING = "OPERATOR_ADD_LOADING";
export const OPERATOR_ADD_INVALID = "OPERATOR_ADD_INVALID";
export const OPERATOR_ADD_SUCCESS = "OPERATOR_ADD_SUCCESS";

export const OPERATOR_DELETE_ERROR = "OPERATOR_DELETE_ERROR";
export const OPERATOR_DELETE_LOADING = "OPERATOR_DELETE_LOADING";
export const OPERATOR_DELETE_SUCCESS = "OPERATOR_DELETE_SUCCESS";

// Track
export const TRACK_URL = "track_log";

export const TRACK_GET_ERROR = "TRACK_HAS_ERROR";
export const TRACK_GET_LOADING = "TRACK_IS_LOADING";
export const TRACK_GET_SUCCESS = "TRACK_IS_SUCCESS";

export const TRACK_VIEW_ERROR = "TRACK_VIEW_ERROR";
export const TRACK_VIEW_LOADING = "TRACK_VIEW_LOADING";
export const TRACK_VIEW_SUCCESS = "TRACK_VIEW_SUCCESS";

export const TRACK_ADD_ERROR = "TRACK_ADD_ERROR";
export const TRACK_ADD_LOADING = "TRACK_ADD_LOADING";
export const TRACK_ADD_SUCCESS = "TRACK_ADD_SUCCESS";

// Commodity
export const COMMODITY_URL = "commodity";
export const COMMODITY_SUPPLIER_URL = "commodity/persupplier";

export const COMMODITY_GET_ERROR = "COMMODITY_HAS_ERROR";
export const COMMODITY_GET_LOADING = "COMMODITY_IS_LOADING";
export const COMMODITY_GET_SUCCESS = "COMMODITY_IS_SUCCESS";

export const COMMODITY_VIEW_ERROR = "COMMODITY_VIEW_ERROR";
export const COMMODITY_VIEW_LOADING = "COMMODITY_VIEW_LOADING";
export const COMMODITY_VIEW_SUCCESS = "COMMODITY_VIEW_SUCCESS";

export const COMMODITY_ADD_ERROR = "COMMODITY_ADD_ERROR";
export const COMMODITY_ADD_LOADING = "COMMODITY_ADD_LOADING";
export const COMMODITY_ADD_INVALID = "COMMODITY_ADD_INVALID";
export const COMMODITY_ADD_SUCCESS = "COMMODITY_ADD_SUCCESS";

export const COMMODITY_DELETE_ERROR = "COMMODITY_DELETE_ERROR";
export const COMMODITY_DELETE_LOADING = "COMMODITY_DELETE_LOADING";
export const COMMODITY_DELETE_SUCCESS = "COMMODITY_DELETE_SUCCESS";

// Trayek
export const ROUTE_URL = "trayek";

export const ROUTE_GET_ERROR = "ROUTE_HAS_ERROR";
export const ROUTE_GET_LOADING = "ROUTE_IS_LOADING";
export const ROUTE_GET_SUCCESS = "ROUTE_IS_SUCCESS";

export const ROUTE_VIEW_ERROR = "ROUTE_VIEW_ERROR";
export const ROUTE_VIEW_LOADING = "ROUTE_VIEW_LOADING";
export const ROUTE_VIEW_SUCCESS = "ROUTE_VIEW_SUCCESS";

export const ROUTE_ADD_ERROR = "ROUTE_ADD_ERROR";
export const ROUTE_ADD_LOADING = "ROUTE_ADD_LOADING";
export const ROUTE_ADD_SUCCESS = "ROUTE_ADD_SUCCESS";

export const ROUTE_DELETE_ERROR = "ROUTE_DELETE_ERROR";
export const ROUTE_DELETE_LOADING = "ROUTE_DELETE_LOADING";
export const ROUTE_DELETE_SUCCESS = "ROUTE_DELETE_SUCCESS";

export const ROUTE_LIST_SHIPPER_ERROR = "ROUTE_LIST_SHIPPER_ERROR";
export const ROUTE_LIST_SHIPPER_LOADING = "ROUTE_LIST_SHIPPER_LOADING";
export const ROUTE_LIST_SHIPPER_SUCCESS = "ROUTE_LIST_SHIPPER_SUCCESS";

// Jadwal Kapal
export const SCHEDULE_URL = "jadwal";

export const SCHEDULE_GET_ERROR = "SCHEDULE_HAS_ERROR";
export const SCHEDULE_GET_LOADING = "SCHEDULE_IS_LOADING";
export const SCHEDULE_GET_SUCCESS = "SCHEDULE_IS_SUCCESS";

export const SCHEDULE_VIEW_ERROR = "SCHEDULE_VIEW_ERROR";
export const SCHEDULE_VIEW_LOADING = "SCHEDULE_VIEW_LOADING";
export const SCHEDULE_VIEW_SUCCESS = "SCHEDULE_VIEW_SUCCESS";

export const SCHEDULE_ADD_ERROR = "SCHEDULE_ADD_ERROR";
export const SCHEDULE_ADD_LOADING = "SCHEDULE_ADD_LOADING";
export const SCHEDULE_ADD_SUCCESS = "SCHEDULE_ADD_SUCCESS";

export const SCHEDULE_DELETE_ERROR = "SCHEDULE_DELETE_ERROR";
export const SCHEDULE_DELETE_LOADING = "SCHEDULE_DELETE_LOADING";
export const SCHEDULE_DELETE_SUCCESS = "SCHEDULE_DELETE_SUCCESS";

export const SCHEDULE_GET_BOOKING = "SCHEDULE_GET_BOOKING";
export const SCHEDULE_GET_CONTAINER_FROM_BOOKING =
  "SCHEDULE_GET_CONTAINER_FROM_BOOKING";
export const SCHEDULE_APPROVE_OR_CANCEL_CONTAINER =
  "SCHEDULE_APPROVE_OR_CANCEL_CONTAINER";
export const SCHEDULE_APPROVE_CANCEL_BOOKING =
  "SCHEDULE_APPROVE_CANCEL_BOOKING";
export const SCHEDULE_ADD_INVALID = "SCHEDULE_ADD_INVALID";
export const SCHEDULE_GET_HISTORY = "SCHEDULE_GET_HISTORY";
export const SCHEDULE_GET_VOYAGE = "SCHEDULE_GET_VOYAGE";
export const SCHEDULE_UBAH_COMMITTED = "SCHEDULE_UBAH_COMMITTED";

// Container
export const CONTAINER_URL = "container";

export const CONTAINER_GET_ERROR = "CONTAINER_HAS_ERROR";
export const CONTAINER_GET_LOADING = "CONTAINER_IS_LOADING";
export const CONTAINER_GET_SUCCESS = "CONTAINER_IS_SUCCESS";

export const CONTAINER_VIEW_ERROR = "CONTAINER_VIEW_ERROR";
export const CONTAINER_VIEW_LOADING = "CONTAINER_VIEW_LOADING";
export const CONTAINER_VIEW_SUCCESS = "CONTAINER_VIEW_SUCCESS";

export const CONTAINER_ADD_ERROR = "CONTAINER_ADD_ERROR";
export const CONTAINER_ADD_LOADING = "CONTAINER_ADD_LOADING";
export const CONTAINER_ADD_SUCCESS = "CONTAINER_ADD_SUCCESS";

// Kemasan
export const KEMASAN_URL = "kemasan";

export const KEMASAN_GET_ERROR = "KEMASAN_HAS_ERROR";
export const KEMASAN_GET_LOADING = "KEMASAN_IS_LOADING";
export const KEMASAN_GET_SUCCESS = "KEMASAN_IS_SUCCESS";

export const KEMASAN_VIEW_ERROR = "KEMASAN_VIEW_ERROR";
export const KEMASAN_VIEW_LOADING = "KEMASAN_VIEW_LOADING";
export const KEMASAN_VIEW_SUCCESS = "KEMASAN_VIEW_SUCCESS";

export const KEMASAN_ADD_ERROR = "KEMASAN_ADD_ERROR";
export const KEMASAN_ADD_LOADING = "KEMASAN_ADD_LOADING";
export const KEMASAN_ADD_SUCCESS = "KEMASAN_ADD_SUCCESS";

// Booking Kapal
export const BOOKING_URL = "booking";

export const BOOKING_GET_ERROR = "BOOKING_HAS_ERROR";
export const BOOKING_GET_LOADING = "BOOKING_IS_LOADING";
export const BOOKING_GET_SUCCESS = "BOOKING_IS_SUCCESS";

export const BOOKING_VIEW_ERROR = "BOOKING_VIEW_ERROR";
export const BOOKING_VIEW_LOADING = "BOOKING_VIEW_LOADING";
export const BOOKING_VIEW_SUCCESS = "BOOKING_VIEW_SUCCESS";

export const BOOKING_ADD_ERROR = "BOOKING_ADD_ERROR";
export const BOOKING_ADD_LOADING = "BOOKING_ADD_LOADING";
export const BOOKING_ADD_SUCCESS = "BOOKING_ADD_SUCCESS";

export const BOOKING_LIST_URL = "booking/list";
export const BOOKING_LIST_ERROR = "BOOKING_LIST_ERROR";
export const BOOKING_LIST_LOADING = "BOOKING_LIST_LOADING";
export const BOOKING_LIST_SUCCESS = "BOOKING_LIST_SUCCESS";
export const BOOKING_REFUND = "BOOKING_REFUND";

// Detail Kontainer
export const DETAILCONTAINER_URL = "detailcontainer";

export const DETAILCONTAINER_GET_ERROR = "DETAILCONTAINER_HAS_ERROR";
export const DETAILCONTAINER_GET_LOADING = "DETAILCONTAINER_IS_LOADING";
export const DETAILCONTAINER_GET_SUCCESS = "DETAILCONTAINER_IS_SUCCESS";

export const DETAILCONTAINER_VIEW_ERROR = "DETAILCONTAINER_VIEW_ERROR";
export const DETAILCONTAINER_VIEW_LOADING = "DETAILCONTAINER_VIEW_LOADING";
export const DETAILCONTAINER_VIEW_SUCCESS = "DETAILCONTAINER_VIEW_SUCCESS";

export const DETAILCONTAINER_ADD_ERROR = "DETAILCONTAINER_ADD_ERROR";
export const DETAILCONTAINER_ADD_LOADING = "DETAILCONTAINER_ADD_LOADING";
export const DETAILCONTAINER_ADD_SUCCESS = "DETAILCONTAINER_ADD_SUCCESS";

export const DETAILCONTAINER_DELETE_ERROR = "DETAILCONTAINER_DELETE_ERROR";
export const DETAILCONTAINER_DELETE_LOADING = "DETAILCONTAINER_DELETE_LOADING";
export const DETAILCONTAINER_DELETE_SUCCESS = "DETAILCONTAINER_DELETE_SUCCESS";

// Pelabuhan
export const PORT_URL = "pelabuhan";

export const PORT_GET_ERROR = "PORT_HAS_ERROR";
export const PORT_GET_LOADING = "PORT_IS_LOADING";
export const PORT_GET_SUCCESS = "PORT_IS_SUCCESS";

export const PORT_VIEW_ERROR = "PORT_VIEW_ERROR";
export const PORT_VIEW_LOADING = "PORT_VIEW_LOADING";
export const PORT_VIEW_SUCCESS = "PORT_VIEW_SUCCESS";

export const PORT_ADD_ERROR = "PORT_ADD_ERROR";
export const PORT_ADD_LOADING = "PORT_ADD_LOADING";
export const PORT_ADD_SUCCESS = "PORT_ADD_SUCCESS";

export const PORT_DELETE_ERROR = "PORT_DELETE_ERROR";
export const PORT_DELETE_LOADING = "PORT_DELETE_LOADING";
export const PORT_DELETE_SUCCESS = "PORT_DELETE_SUCCESS";

// Delivery
export const DELIVERY_URL = "delivery_order";
export const DELIVERY_SUPPLIER_URL = "delivery_order/persupplier";
export const DELIVERY_SHIPPER_URL = "delivery_order/pershipper";

export const DELIVERY_GET_ERROR = "DELIVERY_HAS_ERROR";
export const DELIVERY_GET_LOADING = "DELIVERY_IS_LOADING";
export const DELIVERY_GET_SUCCESS = "DELIVERY_IS_SUCCESS";

export const DELIVERY_VIEW_ERROR = "DELIVERY_VIEW_ERROR";
export const DELIVERY_VIEW_LOADING = "DELIVERY_VIEW_LOADING";
export const DELIVERY_VIEW_SUCCESS = "DELIVERY_VIEW_SUCCESS";

export const DELIVERY_ADD_ERROR = "DELIVERY_ADD_ERROR";
export const DELIVERY_ADD_LOADING = "DELIVERY_ADD_LOADING";
export const DELIVERY_ADD_SUCCESS = "DELIVERY_ADD_SUCCESS";

export const DELIVERY_DELETE_ERROR = "DELIVERY_DELETE_ERROR";
export const DELIVERY_DELETE_LOADING = "DELIVERY_DELETE_LOADING";
export const DELIVERY_DELETE_SUCCESS = "DELIVERY_DELETE_SUCCESS";

// Provinsi
export const PROVINSI_URL = "provinsi";

export const PROVINSI_GET_ERROR = "PROVINSI_HAS_ERROR";
export const PROVINSI_GET_LOADING = "PROVINSI_IS_LOADING";
export const PROVINSI_GET_SUCCESS = "PROVINSI_IS_SUCCESS";

export const PROVINSI_VIEW_ERROR = "PROVINSI_VIEW_ERROR";
export const PROVINSI_VIEW_LOADING = "PROVINSI_VIEW_LOADING";
export const PROVINSI_VIEW_SUCCESS = "PROVINSI_VIEW_SUCCESS";

export const PROVINSI_ADD_ERROR = "PROVINSI_ADD_ERROR";
export const PROVINSI_ADD_LOADING = "PROVINSI_ADD_LOADING";
export const PROVINSI_ADD_SUCCESS = "PROVINSI_ADD_SUCCESS";

// custom params edit doc status
export const EDIT_DOC_STATUS_URL = "custom_params/EDIT_DOC_STATUS";
export const EDIT_DOC_STATUS_GET_ERROR = "EDIT_DOC_STATUS_HAS_ERROR";
export const EDIT_DOC_STATUS_GET_LOADING = "EDIT_DOC_STATUS_IS_LOADING";
export const EDIT_DOC_STATUS_GET_SUCCESS = "EDIT_DOC_STATUS_IS_SUCCESS";

// Kota
export const KOTA_URL = "kota";

export const KOTA_GET_ERROR = "KOTA_HAS_ERROR";
export const KOTA_GET_LOADING = "KOTA_IS_LOADING";
export const KOTA_GET_SUCCESS = "KOTA_IS_SUCCESS";

export const KOTA_VIEW_ERROR = "KOTA_VIEW_ERROR";
export const KOTA_VIEW_LOADING = "KOTA_VIEW_LOADING";
export const KOTA_VIEW_SUCCESS = "KOTA_VIEW_SUCCESS";

export const KOTA_ADD_ERROR = "KOTA_ADD_ERROR";
export const KOTA_ADD_LOADING = "KOTA_ADD_LOADING";
export const KOTA_ADD_SUCCESS = "KOTA_ADD_SUCCESS";

// Type Container
export const TYPECONTAINER_URL = "typecontainer";

export const TYPECONTAINER_GET_ERROR = "TYPECONTAINER_HAS_ERROR";
export const TYPECONTAINER_GET_LOADING = "TYPECONTAINER_IS_LOADING";
export const TYPECONTAINER_GET_SUCCESS = "TYPECONTAINER_IS_SUCCESS";

export const TYPECONTAINER_VIEW_ERROR = "TYPECONTAINER_VIEW_ERROR";
export const TYPECONTAINER_VIEW_LOADING = "TYPECONTAINER_VIEW_LOADING";
export const TYPECONTAINER_VIEW_SUCCESS = "TYPECONTAINER_VIEW_SUCCESS";

export const TYPECONTAINER_ADD_ERROR = "TYPECONTAINER_ADD_ERROR";
export const TYPECONTAINER_ADD_LOADING = "TYPECONTAINER_ADD_LOADING";
export const TYPECONTAINER_ADD_SUCCESS = "TYPECONTAINER_ADD_SUCCESS";

export const TYPECONTAINER_DELETE_ERROR = "TYPECONTAINER_DELETE_ERROR";
export const TYPECONTAINER_DELETE_LOADING = "TYPECONTAINER_DELETE_LOADING";
export const TYPECONTAINER_DELETE_SUCCESS = "TYPECONTAINER_DELETE_SUCCESS";

// Kemasan
export const PACKAGING_URL = "kemasan";

export const PACKAGING_GET_ERROR = "PACKAGING_HAS_ERROR";
export const PACKAGING_GET_LOADING = "PACKAGING_IS_LOADING";
export const PACKAGING_GET_SUCCESS = "PACKAGING_IS_SUCCESS";

export const PACKAGING_VIEW_ERROR = "PACKAGING_VIEW_ERROR";
export const PACKAGING_VIEW_LOADING = "PACKAGING_VIEW_LOADING";
export const PACKAGING_VIEW_SUCCESS = "PACKAGING_VIEW_SUCCESS";

export const PACKAGING_ADD_ERROR = "PACKAGING_ADD_ERROR";
export const PACKAGING_ADD_LOADING = "PACKAGING_ADD_LOADING";
export const PACKAGING_ADD_SUCCESS = "PACKAGING_ADD_SUCCESS";

export const PACKAGING_DELETE_ERROR = "PACKAGING_DELETE_ERROR";
export const PACKAGING_DELETE_LOADING = "PACKAGING_DELETE_LOADING";
export const PACKAGING_DELETE_SUCCESS = "PACKAGING_DELETE_SUCCESS";

// Satuan
export const UNIT_URL = "satuan";

export const UNIT_GET_ERROR = "UNIT_HAS_ERROR";
export const UNIT_GET_LOADING = "UNIT_IS_LOADING";
export const UNIT_GET_SUCCESS = "UNIT_IS_SUCCESS";

export const UNIT_VIEW_ERROR = "UNIT_VIEW_ERROR";
export const UNIT_VIEW_LOADING = "UNIT_VIEW_LOADING";
export const UNIT_VIEW_SUCCESS = "UNIT_VIEW_SUCCESS";

export const UNIT_ADD_ERROR = "UNIT_ADD_ERROR";
export const UNIT_ADD_LOADING = "UNIT_ADD_LOADING";
export const UNIT_ADD_SUCCESS = "UNIT_ADD_SUCCESS";

export const UNIT_DELETE_ERROR = "UNIT_DELETE_ERROR";
export const UNIT_DELETE_LOADING = "UNIT_DELETE_LOADING";
export const UNIT_DELETE_SUCCESS = "UNIT_DELETE_SUCCESS";

// Jenisbarang
export const JENISBARANG_URL = "jenis_barang";

export const JENISBARANG_GET_ERROR = "JENISBARANG_HAS_ERROR";
export const JENISBARANG_GET_LOADING = "JENISBARANG_IS_LOADING";
export const JENISBARANG_GET_SUCCESS = "JENISBARANG_IS_SUCCESS";

export const JENISBARANG_VIEW_ERROR = "JENISBARANG_VIEW_ERROR";
export const JENISBARANG_VIEW_LOADING = "JENISBARANG_VIEW_LOADING";
export const JENISBARANG_VIEW_SUCCESS = "JENISBARANG_VIEW_SUCCESS";

export const JENISBARANG_ADD_ERROR = "JENISBARANG_ADD_ERROR";
export const JENISBARANG_ADD_LOADING = "JENISBARANG_ADD_LOADING";
export const JENISBARANG_ADD_SUCCESS = "JENISBARANG_ADD_SUCCESS";

export const JENISBARANG_EDIT_ERROR = "JENISBARANG_EDIT_ERROR";
export const JENISBARANG_EDIT_LOADING = "JENISBARANG_EDIT_LOADING";
export const JENISBARANG_EDIT_SUCCESS = "JENISBARANG_EDIT_SUCCESS";

export const JENISBARANG_DELETE_ERROR = "JENISBARANG_DELETE_ERROR";
export const JENISBARANG_DELETE_LOADING = "JENISBARANG_DELETE_LOADING";
export const JENISBARANG_DELETE_SUCCESS = "JENISBARANG_DELETE_SUCCESS";

// Jeniscommodity
export const JENISCOMMODITY_URL = "jenis_commodity";

export const JENISCOMMODITY_GET_ERROR = "JENISCOMMODITY_HAS_ERROR";
export const JENISCOMMODITY_GET_LOADING = "JENISCOMMODITY_IS_LOADING";
export const JENISCOMMODITY_GET_SUCCESS = "JENISCOMMODITY_IS_SUCCESS";

export const JENISCOMMODITY_VIEW_ERROR = "JENISCOMMODITY_VIEW_ERROR";
export const JENISCOMMODITY_VIEW_LOADING = "JENISCOMMODITY_VIEW_LOADING";
export const JENISCOMMODITY_VIEW_SUCCESS = "JENISCOMMODITY_VIEW_SUCCESS";

export const JENISCOMMODITY_ADD_ERROR = "JENISCOMMODITY_ADD_ERROR";
export const JENISCOMMODITY_ADD_LOADING = "JENISCOMMODITY_ADD_LOADING";
export const JENISCOMMODITY_ADD_SUCCESS = "JENISCOMMODITY_ADD_SUCCESS";

export const JENISCOMMODITY_DELETE_ERROR = "JENISCOMMODITY_DELETE_ERROR";
export const JENISCOMMODITY_DELETE_LOADING = "JENISCOMMODITY_DELETE_LOADING";
export const JENISCOMMODITY_DELETE_SUCCESS = "JENISCOMMODITY_DELETE_SUCCESS";

// Distribution
export const DISTRIBUTION_URL = "distribusibarang";

export const DISTRIBUTION_GET_ERROR = "DISTRIBUTION_HAS_ERROR";
export const DISTRIBUTION_GET_LOADING = "DISTRIBUTION_IS_LOADING";
export const DISTRIBUTION_GET_SUCCESS = "DISTRIBUTION_IS_SUCCESS";

export const DISTRIBUTION_VIEW_ERROR = "DISTRIBUTION_VIEW_ERROR";
export const DISTRIBUTION_VIEW_LOADING = "DISTRIBUTION_VIEW_LOADING";
export const DISTRIBUTION_VIEW_SUCCESS = "DISTRIBUTION_VIEW_SUCCESS";

export const DISTRIBUTION_ADD_ERROR = "DISTRIBUTION_ADD_ERROR";
export const DISTRIBUTION_ADD_LOADING = "DISTRIBUTION_ADD_LOADING";
export const DISTRIBUTION_ADD_SUCCESS = "DISTRIBUTION_ADD_SUCCESS";

// Reseller
export const RESELLER_URL = "reseller";

export const RESELLER_GET_ERROR = "RESELLER_HAS_ERROR";
export const RESELLER_GET_LOADING = "RESELLER_IS_LOADING";
export const RESELLER_GET_SUCCESS = "RESELLER_IS_SUCCESS";

export const RESELLER_VIEW_ERROR = "RESELLER_VIEW_ERROR";
export const RESELLER_VIEW_LOADING = "RESELLER_VIEW_LOADING";
export const RESELLER_VIEW_SUCCESS = "RESELLER_VIEW_SUCCESS";

export const RESELLER_ADD_ERROR = "RESELLER_ADD_ERROR";
export const RESELLER_ADD_LOADING = "RESELLER_ADD_LOADING";
export const RESELLER_ADD_INVALID = "RESELLER_ADD_INVALID";
export const RESELLER_ADD_SUCCESS = "RESELLER_ADD_SUCCESS";

export const RESELLER_DELETE_ERROR = "RESELLER_DELETE_ERROR";
export const RESELLER_DELETE_LOADING = "RESELLER_DELETE_LOADING";
export const RESELLER_DELETE_SUCCESS = "RESELLER_DELETE_SUCCESS";

// Depot
export const DEPOT_URL = "depot";

export const DEPOT_GET_ERROR = "DEPOT_HAS_ERROR";
export const DEPOT_GET_LOADING = "DEPOT_IS_LOADING";
export const DEPOT_GET_SUCCESS = "DEPOT_IS_SUCCESS";

export const DEPOT_VIEW_ERROR = "DEPOT_VIEW_ERROR";
export const DEPOT_VIEW_LOADING = "DEPOT_VIEW_LOADING";
export const DEPOT_VIEW_SUCCESS = "DEPOT_VIEW_SUCCESS";

export const DEPOT_ADD_ERROR = "DEPOT_ADD_ERROR";
export const DEPOT_ADD_LOADING = "DEPOT_ADD_LOADING";
export const DEPOT_ADD_SUCCESS = "DEPOT_ADD_SUCCESS";

export const DEPOT_DELETE_ERROR = "DEPOT_DELETE_ERROR";
export const DEPOT_DELETE_LOADING = "DEPOT_DELETE_LOADING";
export const DEPOT_DELETE_SUCCESS = "DEPOT_DELETE_SUCCESS";

// Product
export const PRODUCT_URL = "distribution";

export const PRODUCT_GET_ERROR = "PRODUCT_HAS_ERROR";
export const PRODUCT_GET_LOADING = "PRODUCT_IS_LOADING";
export const PRODUCT_GET_SUCCESS = "PRODUCT_IS_SUCCESS";

export const PRODUCT_VIEW_ERROR = "PRODUCT_VIEW_ERROR";
export const PRODUCT_VIEW_LOADING = "PRODUCT_VIEW_LOADING";
export const PRODUCT_VIEW_SUCCESS = "PRODUCT_VIEW_SUCCESS";

export const PRODUCT_ADD_ERROR = "PRODUCT_ADD_ERROR";
export const PRODUCT_ADD_LOADING = "PRODUCT_ADD_LOADING";
export const PRODUCT_ADD_SUCCESS = "PRODUCT_ADD_SUCCESS";

export const PRODUCT_DELETE_ERROR = "PRODUCT_DELETE_ERROR";
export const PRODUCT_DELETE_LOADING = "PRODUCT_DELETE_LOADING";
export const PRODUCT_DELETE_SUCCESS = "PRODUCT_DELETE_SUCCESS";

// Vessel
export const VESSEL_URL = "kapal";

export const VESSEL_GET_ERROR = "VESSEL_HAS_ERROR";
export const VESSEL_GET_LOADING = "VESSEL_IS_LOADING";
export const VESSEL_GET_SUCCESS = "VESSEL_IS_SUCCESS";

export const VESSEL_VIEW_ERROR = "VESSEL_VIEW_ERROR";
export const VESSEL_VIEW_LOADING = "VESSEL_VIEW_LOADING";
export const VESSEL_VIEW_SUCCESS = "VESSEL_VIEW_SUCCESS";

export const VESSEL_ADD_ERROR = "VESSEL_ADD_ERROR";
export const VESSEL_ADD_LOADING = "VESSEL_ADD_LOADING";
export const VESSEL_ADD_INVALID = "VESSEL_ADD_INVALID";
export const VESSEL_ADD_SUCCESS = "VESSEL_ADD_SUCCESS";

export const VESSEL_DELETE_ERROR = "VESSEL_DELETE_ERROR";
export const VESSEL_DELETE_LOADING = "VESSEL_DELETE_LOADING";
export const VESSEL_DELETE_SUCCESS = "VESSEL_DELETE_SUCCESS";

// Pengaduan
export const COMPLAINT_URL = "pengaduan";

export const COMPLAINT_GET_ERROR = "COMPLAINT_HAS_ERROR";
export const COMPLAINT_GET_LOADING = "COMPLAINT_IS_LOADING";
export const COMPLAINT_GET_SUCCESS = "COMPLAINT_IS_SUCCESS";

export const COMPLAINT_VIEW_ERROR = "COMPLAINT_VIEW_ERROR";
export const COMPLAINT_VIEW_LOADING = "COMPLAINT_VIEW_LOADING";
export const COMPLAINT_VIEW_SUCCESS = "COMPLAINT_VIEW_SUCCESS";

export const COMPLAINT_ADD_ERROR = "COMPLAINT_ADD_ERROR";
export const COMPLAINT_ADD_LOADING = "COMPLAINT_ADD_LOADING";
export const COMPLAINT_ADD_SUCCESS = "COMPLAINT_ADD_SUCCESS";

export const COMPLAINT_DELETE_ERROR = "COMPLAINT_DELETE_ERROR";
export const COMPLAINT_DELETE_LOADING = "COMPLAINT_DELETE_LOADING";
export const COMPLAINT_DELETE_SUCCESS = "COMPLAINT_DELETE_SUCCESS";

export const COMPLAINT_REPLY_ERROR = "COMPLAINT_REPLY_ERROR";
export const COMPLAINT_REPLY_LOADING = "COMPLAINT_REPLY_LOADING";
export const COMPLAINT_REPLY_SUCCESS = "COMPLAINT_REPLY_SUCCESS";

export const COMPLAINT_CLOSE_ERROR = "COMPLAINT_CLOSE_ERROR";
export const COMPLAINT_CLOSE_LOADING = "COMPLAINT_CLOSE_LOADING";
export const COMPLAINT_CLOSE_SUCCESS = "COMPLAINT_CLOSE_SUCCESS";

export const COMPLAINT_EKSKALASI_ERROR = "COMPLAINT_EKSKALASI_ERROR";
export const COMPLAINT_EKSKALASI_LOADING = "COMPLAINT_EKSKALASI_LOADING";
export const COMPLAINT_EKSKALASI_SUCCESS = "COMPLAINT_EKSKALASI_SUCCESS";

export const COMPLAINT_USER_TYPE_ERROR = "COMPLAINT_USER_TYPE_ERROR";
export const COMPLAINT_USER_TYPE_LOADING = "COMPLAINT_USER_TYPE_LOADING";
export const COMPLAINT_USER_TYPE_SUCCESS = "COMPLAINT_USER_TYPE_SUCCESS";

export const COMPLAINT_USER_EKSKALASI_ERROR = "COMPLAINT_USER_EKSKALASI_ERROR";
export const COMPLAINT_USER_EKSKALASI_LOADING =
  "COMPLAINT_USER_EKSKALASI_LOADING";
export const COMPLAINT_USER_EKSKALASI_SUCCESS =
  "COMPLAINT_USER_EKSKALASI_SUCCESS";

export const COMPLAINT_CATEGORIES_ERROR = "COMPLAINT_CATEGORIES_ERROR";
export const COMPLAINT_CATEGORIES_LOADING = "COMPLAINT_CATEGORIES_LOADING";
export const COMPLAINT_CATEGORIES_SUCCESS = "COMPLAINT_CATEGORIES_SUCCESS";

// Master Trayek
export const MSTTRAYEK_URL = "master_trayek";

export const MSTTRAYEK_GET_ERROR = "MSTTRAYEK_HAS_ERROR";
export const MSTTRAYEK_GET_LOADING = "MSTTRAYEK_IS_LOADING";
export const MSTTRAYEK_GET_SUCCESS = "MSTTRAYEK_IS_SUCCESS";

export const MSTTRAYEK_VIEW_ERROR = "MSTTRAYEK_VIEW_ERROR";
export const MSTTRAYEK_VIEW_LOADING = "MSTTRAYEK_VIEW_LOADING";
export const MSTTRAYEK_VIEW_SUCCESS = "MSTTRAYEK_VIEW_SUCCESS";

export const MSTTRAYEK_ADD_ERROR = "MSTTRAYEK_ADD_ERROR";
export const MSTTRAYEK_ADD_LOADING = "MSTTRAYEK_ADD_LOADING";
export const MSTTRAYEK_ADD_SUCCESS = "MSTTRAYEK_ADD_SUCCESS";

export const MSTTRAYEK_DELETE_ERROR = "MSTTRAYEK_DELETE_ERROR";
export const MSTTRAYEK_DELETE_LOADING = "MSTTRAYEK_DELETE_LOADING";
export const MSTTRAYEK_DELETE_SUCCESS = "MSTTRAYEK_DELETE_SUCCESS";

// Statistic
export const CONSIGNEE_STATISTIC_URL = "consignee/statistic";
export const SUPPLIER_STATISTIC_URL = "supplier/statistic";
export const SHIPPER_STATISTIC_URL = "shipper/statistic";
export const RESELLER_STATISTIC_URL = "reseller/statistic";
export const OPERATOR_STATISTIC_URL = "operator/statistic";
export const REGULATOR_STATISTIC_URL = "regulator/statistic";

export const CONSIGNEE_STTC_ALL_ERROR = "CONSIGNEE_STTC_ALL_ERROR";
export const CONSIGNEE_STTC_ALL_LOADING = "CONSIGNEE_STTC_ALL_LOADING";
export const CONSIGNEE_STTC_ALL_SUCCESS = "CONSIGNEE_STTC_ALL_SUCCESS";

export const CONSIGNEE_STTC_ACTIVE_ERROR = "CONSIGNEE_STTC_ACTIVE_ERROR";
export const CONSIGNEE_STTC_ACTIVE_LOADING = "CONSIGNEE_STTC_ACTIVE_LOADING";
export const CONSIGNEE_STTC_ACTIVE_SUCCESS = "CONSIGNEE_STTC_ACTIVE_SUCCESS";

export const SUPPLIER_STTC_ALL_ERROR = "SUPPLIER_STTC_ALL_ERROR";
export const SUPPLIER_STTC_ALL_LOADING = "SUPPLIER_STTC_ALL_LOADING";
export const SUPPLIER_STTC_ALL_SUCCESS = "SUPPLIER_STTC_ALL_SUCCESS";

export const SUPPLIER_STTC_ACTIVE_ERROR = "SUPPLIER_STTC_ACTIVE_ERROR";
export const SUPPLIER_STTC_ACTIVE_LOADING = "SUPPLIER_STTC_ACTIVE_LOADING";
export const SUPPLIER_STTC_ACTIVE_SUCCESS = "SUPPLIER_STTC_ACTIVE_SUCCESS";

export const SHIPPER_STTC_ALL_ERROR = "SHIPPER_STTC_ALL_ERROR";
export const SHIPPER_STTC_ALL_LOADING = "SHIPPER_STTC_ALL_LOADING";
export const SHIPPER_STTC_ALL_SUCCESS = "SHIPPER_STTC_ALL_SUCCESS";

export const SHIPPER_STTC_ACTIVE_ERROR = "SHIPPER_STTC_ACTIVE_ERROR";
export const SHIPPER_STTC_ACTIVE_LOADING = "SHIPPER_STTC_ACTIVE_LOADING";
export const SHIPPER_STTC_ACTIVE_SUCCESS = "SHIPPER_STTC_ACTIVE_SUCCESS";

export const RESELLER_STTC_ALL_ERROR = "RESELLER_STTC_ALL_ERROR";
export const RESELLER_STTC_ALL_LOADING = "RESELLER_STTC_ALL_LOADING";
export const RESELLER_STTC_ALL_SUCCESS = "RESELLER_STTC_ALL_SUCCESS";

export const RESELLER_STTC_ACTIVE_ERROR = "RESELLER_STTC_ACTIVE_ERROR";
export const RESELLER_STTC_ACTIVE_LOADING = "RESELLER_STTC_ACTIVE_LOADING";
export const RESELLER_STTC_ACTIVE_SUCCESS = "RESELLER_STTC_ACTIVE_SUCCESS";

export const OPERATOR_STTC_ALL_ERROR = "OPERATOR_STTC_ALL_ERROR";
export const OPERATOR_STTC_ALL_LOADING = "OPERATOR_STTC_ALL_LOADING";
export const OPERATOR_STTC_ALL_SUCCESS = "OPERATOR_STTC_ALL_SUCCESS";

export const OPERATOR_STTC_ACTIVE_ERROR = "OPERATOR_STTC_ACTIVE_ERROR";
export const OPERATOR_STTC_ACTIVE_LOADING = "OPERATOR_STTC_ACTIVE_LOADING";
export const OPERATOR_STTC_ACTIVE_SUCCESS = "OPERATOR_STTC_ACTIVE_SUCCESS";

export const REGULATOR_STTC_ALL_ERROR = "REGULATOR_STTC_ALL_ERROR";
export const REGULATOR_STTC_ALL_LOADING = "REGULATOR_STTC_ALL_LOADING";
export const REGULATOR_STTC_ALL_SUCCESS = "REGULATOR_STTC_ALL_SUCCESS";

export const REGULATOR_STTC_ACTIVE_ERROR = "REGULATOR_STTC_ACTIVE_ERROR";
export const REGULATOR_STTC_ACTIVE_LOADING = "REGULATOR_STTC_ACTIVE_LOADING";
export const REGULATOR_STTC_ACTIVE_SUCCESS = "REGULATOR_STTC_ACTIVE_SUCCESS";

export const OPERATOR_NAME_ERROR = "OPERATOR_NAME_ERROR";
export const OPERATOR_NAME_LOADING = "OPERATOR_NAME_LOADING";
export const OPERATOR_NAME_SUCCESS = "OPERATOR_NAME_SUCCESS";

// Vessel Tracking Dashboard
export const VESSEL_TRACKING_URL = "vessel_tracking";
export const VESSEL_TRACKING_GET_ERROR = "VESSEL_TRACKING_GET_ERROR";
export const VESSEL_TRACKING_GET_LOADING = "VESSEL_TRACKING_GET_LOADING";
export const VESSEL_TRACKING_GET_SUCCESS = "VESSEL_TRACKING_GET_SUCCESS";

export const VESSEL_TRACKING_VIEW_ERROR = "VESSEL_TRACKING_VIEW_ERROR";
export const VESSEL_TRACKING_VIEW_LOADING = "VESSEL_TRACKING_VIEW_LOADING";
export const VESSEL_TRACKING_VIEW_SUCCESS = "VESSEL_TRACKING_VIEW_SUCCESS";

// Tracking Data
export const TRACKING_DATA_URL = "tracking_data";
export const TRACKING_DATA_GET_ERROR = "TRACKING_DATA_GET_ERROR";
export const TRACKING_DATA_GET_LOADING = "TRACKING_DATA_GET_LOADING";
export const TRACKING_DATA_GET_SUCCESS = "TRACKING_DATA_GET_SUCCESS";

// Manifest
export const MANIFEST_URL = "manifest";

export const MANIFEST_GET_LOADING = "MANIFEST_GET_LOADING";
export const MANIFEST_GET_ERROR = "MANIFEST_GET_ERROR";
export const MANIFEST_GET_SUCCESS = "MANIFEST_GET_SUCCESS";

export const MANIFEST_VIEW_LOADING = "MANIFEST_VIEW_LOADING";
export const MANIFEST_VIEW_ERROR = "MANIFEST_VIEW_ERROR";
export const MANIFEST_VIEW_SUCCESS = "MANIFEST_VIEW_SUCCESS";

// Booking Has DO
export const BOOKING_HAS_DO_VIEW_URL = "booking/consignee/view";
export const BOOKING_HAS_DO_UPDATE_URL = "booking/consignee/update";

export const BOOKING_HAS_DO_VIEW_LOADING = "BOOKING_HAS_DO_VIEW_LOADING";
export const BOOKING_HAS_DO_VIEW_ERROR = "BOOKING_HAS_DO_VIEW_ERROR";
export const BOOKING_HAS_DO_VIEW_SUCCESS = "BOOKING_HAS_DO_VIEW_SUCCESS";

export const BOOKING_HAS_DO_UPDATE_LOADING = "BOOKING_HAS_DO_UPDATE_LOADING";
export const BOOKING_HAS_DO_UPDATE_ERROR = "BOOKING_HAS_DO_UPDATE_ERROR";
export const BOOKING_HAS_DO_UPDATE_INVALID = "BOOKING_HAS_DO_UPDATE_INVALID";
export const BOOKING_HAS_DO_UPDATE_SUCCESS = "BOOKING_HAS_DO_UPDATE_SUCCESS";

// Dashboard (Statistic)

// order per jenis prioritas
export const ORDER_PER_JENIS_PRIORITAS_URL =
  "dashboard/order_per_jenis_prioritas";
export const ORDER_PER_JENIS_PRIORITAS_GET_LOADING =
  "ORDER_PER_JENIS_PRIORITAS_GET_LOADING";
export const ORDER_PER_JENIS_PRIORITAS_GET_ERROR =
  "ORDER_PER_JENIS_PRIORITAS_GET_ERROR";
export const ORDER_PER_JENIS_PRIORITAS_GET_SUCCESS =
  "ORDER_PER_JENIS_PRIORITAS_GET_SUCCESS";

// lima muatan terbanyak
export const MUATAN_TERBANYAK_URL = "dashboard/lima_muatan_terbanyak";
export const MUATAN_TERBANYAK_GET_LOADING = "MUATAN_TERBANYAK_GET_LOADING";
export const MUATAN_TERBANYAK_GET_ERROR = "MUATAN_TERBANYAK_GET_ERROR";
export const MUATAN_TERBANYAK_GET_SUCCESS = "MUATAN_TERBANYAK_GET_SUCCESS";

// container pertahun
export const CONTAINER_PER_TAHUN_URL = "dashboard/container_per_tahun";
export const CONTAINER_PER_TAHUN_GET_LOADING =
  "CONTAINER_PER_TAHUN_GET_LOADING";
export const CONTAINER_PER_TAHUN_GET_ERROR = "CONTAINER_PER_TAHUN_GET_ERROR";
export const CONTAINER_PER_TAHUN_GET_SUCCESS =
  "CONTAINER_PER_TAHUN_GET_SUCCESS";

// muatan per wilayah
export const MUATAN_PER_WILAYAH_URL = "dashboard/muatan_per_wilayah";
export const MUATAN_PER_WILAYAH_GET_LOADING = "MUATAN_PER_WILAYAH_GET_LOADING";
export const MUATAN_PER_WILAYAH_GET_ERROR = "MUATAN_PER_WILAYAH_GET_ERROR";
export const MUATAN_PER_WILAYAH_GET_SUCCESS = "MUATAN_PER_WILAYAH_GET_SUCCESS";

// muatan per wilayah per prioritas
export const MUATAN_PER_WILAYAH_PER_PRIORITAS_URL =
  "dashboard/muatan_per_wilayah_per_prioritas";
export const MUATAN_PER_WILAYAH_PER_PRIORITAS_GET_LOADING =
  "MUATAN_PER_WILAYAH_PER_PRIORITAS_GET_LOADING";
export const MUATAN_PER_WILAYAH_PER_PRIORITAS_GET_ERROR =
  "MUATAN_PER_WILAYAH_PER_PRIORITAS_GET_ERROR";
export const MUATAN_PER_WILAYAH_PER_PRIORITAS_GET_SUCCESS =
  "MUATAN_PER_WILAYAH_PER_PRIORITAS_GET_SUCCESS";

// order sudah dibayar
export const ORDER_PAID_URL = "dashboard/paid";
export const ORDER_PAID_GET_LOADING = "ORDER_PAID_GET_LOADING";
export const ORDER_PAID_GET_ERROR = "ORDER_PAID_GET_ERROR";
export const ORDER_PAID_GET_SUCCESS = "ORDER_PAID_GET_SUCCESS";

// order belum dibayar
export const ORDER_UNPAID_URL = "dashboard/unpaid";
export const ORDER_UNPAID_GET_LOADING = "ORDER_UNPAID_GET_LOADING";
export const ORDER_UNPAID_GET_ERROR = "ORDER_UNPAID_GET_ERROR";
export const ORDER_UNPAID_GET_SUCCESS = "ORDER_UNPAID_GET_SUCCESS";

// order ditolak
export const ORDER_DENIED_URL = "dashboard/order_denied";
export const ORDER_DENIED_GET_LOADING = "ORDER_DENIED_GET_LOADING";
export const ORDER_DENIED_GET_ERROR = "ORDER_DENIED_GET_ERROR";
export const ORDER_DENIED_GET_SUCCESS = "ORDER_DENIED_GET_SUCCESS";

// semua order
export const ALL_ORDER_URL = "dashboard/all_orders";
export const ALL_ORDER_GET_LOADING = "ALL_ORDER_GET_LOADING";
export const ALL_ORDER_GET_ERROR = "ALL_ORDER_GET_ERROR";
export const ALL_ORDER_GET_SUCCESS = "ALL_ORDER_GET_SUCCESS";

// order per bulan
export const ORDER_PER_BULAN_URL = "dashboard/order_per_bulan";
export const ORDER_PER_BULAN_GET_LOADING = "ORDER_PER_BULAN_GET_LOADING";
export const ORDER_PER_BULAN_GET_ERROR = "ORDER_PER_BULAN_GET_ERROR";
export const ORDER_PER_BULAN_GET_SUCCESS = "ORDER_PER_BULAN_GET_SUCCESS";

// muatan per operator
export const MUATAN_PER_OPERATOR_URL = "dashboard/muatan_per_operator";
export const MUATAN_PER_OPERATOR_GET_LOADING =
  "MUATAN_PER_OPERATOR_GET_LOADING";
export const MUATAN_PER_OPERATOR_GET_ERROR = "MUATAN_PER_OPERATOR_GET_ERROR";
export const MUATAN_PER_OPERATOR_GET_SUCCESS =
  "MUATAN_PER_OPERATOR_GET_SUCCESS";

// disparitas harga
export const DISPARITAS_HARGA_URL = "dashboard/disparitas_harga";
export const DISPARITAS_HARGA_GET_LOADING = "DISPARITAS_HARGA_GET_LOADING";
export const DISPARITAS_HARGA_GET_ERROR = "DISPARITAS_HARGA_GET_ERROR";
export const DISPARITAS_HARGA_GET_SUCCESS = "DISPARITAS_HARGA_GET_SUCCESS";

// Sisa quota trayek
export const SISA_QUOTA_TRAYEK_URL = "dashboard/sisa_quota_trayek";
export const SISA_QUOTA_TRAYEK_GET_LOADING = "SISA_QUOTA_TRAYEK_GET_LOADING";
export const SISA_QUOTA_TRAYEK_GET_ERROR = "SISA_QUOTA_TRAYEK_GET_ERROR";
export const SISA_QUOTA_TRAYEK_GET_SUCCESS = "SISA_QUOTA_TRAYEK_GET_SUCCESS";
// nic
export const SISA_QUOTA_TRAYEK_GET_LOADING_PerBulan =
  "SISA_QUOTA_TRAYEK_GET_LOADING_PerBulan";
export const SISA_QUOTA_TRAYEK_GET_ERROR_PerBulan =
  "SISA_QUOTA_TRAYEK_GET_ERROR_PerBulan";
export const SISA_QUOTA_TRAYEK_GET_SUCCESS_PerBulan =
  "SISA_QUOTA_TRAYEK_GET_SUCCESS_PerBulan";

// voyage per trayek
export const VOYAGE_PER_TRAYEK_URL = "dashboard/voyage_per_trayek";
export const VOYAGE_PER_TRAYEK_GET_LOADING = "VOYAGE_PER_TRAYEK_GET_LOADING";
export const VOYAGE_PER_TRAYEK_GET_ERROR = "VOYAGE_PER_TRAYEK_GET_ERROR";
export const VOYAGE_PER_TRAYEK_GET_SUCCESS = "VOYAGE_PER_TRAYEK_GET_SUCCESS";

// PO
export const PO_URL = "dashboard/purchase_order";
export const PO_GET_LOADING = "PO_GET_LOADING";
export const PO_GET_ERROR = "PO_GET_ERROR";
export const PO_GET_SUCCESS = "PO_GET_SUCCESS";

// Commodity
export const DASHBOARD_COMMODITY_URL = "dashboard/commodity";
export const DASHBOARD_COMMODITY_LOADING = "DASHBOARD_COMMODITY_LOADING";
export const DASHBOARD_COMMODITY_ERROR = "DASHBOARD_COMMODITY_ERROR";
export const DASHBOARD_COMMODITY_SUCCESS = "DASHBOARD_COMMODITY_SUCCESS";

// DO
export const DO_URL = "dashboard/delivery_order";
export const DO_GET_LOADING = "DO_GET_LOADING";
export const DO_GET_ERROR = "DO_GET_ERROR";
export const DO_GET_SUCCESS = "DO_GET_SUCCESS";

// realisasi
export const REALISASI_URL = "dashboard/realisasi";
export const REALISASI_GET_LOADING = "REALISASI_GET_LOADING";
export const REALISASI_GET_ERROR = "REALISASI_GET_ERROR";
export const REALISASI_GET_SUCCESS = "REALISASI_GET_SUCCESS";

// waktu tempuh
export const WAKTU_TEMPUH_URL = "dashboard/waktu_tempuh";
export const WAKTU_TEMPUH_GET_LOADING = "WAKTU_TEMPUH_GET_LOADING";
export const WAKTU_TEMPUH_GET_ERROR = "WAKTU_TEMPUH_GET_ERROR";
export const WAKTU_TEMPUH_GET_SUCCESS = "WAKTU_TEMPUH_GET_SUCCESS";

// jadwal kapal
export const JADWAL_KAPAL_URL = "dashboard/jadwal";
export const JADWAL_KAPAL_GET_LOADING = "JADWAL_KAPAL_GET_LOADING";
export const JADWAL_KAPAL_GET_ERROR = "JADWAL_KAPAL_GET_ERROR";
export const JADWAL_KAPAL_GET_SUCCESS = "JADWAL_KAPAL_GET_SUCCESS";

// booking vessel
export const BOOKING_VESSEL_URL = "dashboard/booking";
export const BOOKING_VESSEL_GET_LOADING = "BOOKING_VESSEL_GET_LOADING";
export const BOOKING_VESSEL_GET_ERROR = "BOOKING_VESSEL_GET_ERROR";
export const BOOKING_VESSEL_GET_SUCCESS = "BOOKING_VESSEL_GET_SUCCESS";

// distribusi barang
export const DISTRIBUSI_BARANG_URL = "dashboard/distribusi_barang";
export const DISTRIBUSI_BARANG_GET_LOADING = "DISTRIBUSI_BARANG_GET_LOADING";
export const DISTRIBUSI_BARANG_GET_ERROR = "DISTRIBUSI_BARANG_GET_ERROR";
export const DISTRIBUSI_BARANG_GET_SUCCESS = "DISTRIBUSI_BARANG_GET_SUCCESS";

// Update price
export const TYPECONTAINER_PRICE_UPDATE_URL = "typecontainer/rates";
export const TYPECONTAINER_PRICE_UPDATE_ERROR =
  "TYPECONTAINER_PRICE_UPDATE_ERROR";
export const TYPECONTAINER_PRICE_UPDATE_LOADING =
  "TYPECONTAINER_PRICE_UPDATE_LOADING";
export const TYPECONTAINER_PRICE_UPDATE_SUCCESS =
  "TYPECONTAINER_PRICE_UPDATE_SUCCESS";

// Tarif
export const PRICE_URL = "master_tarif";

export const PRICE_GET_ERROR = "PRICE_HAS_ERROR";
export const PRICE_GET_LOADING = "PRICE_IS_LOADING";
export const PRICE_GET_SUCCESS = "PRICE_IS_SUCCESS";

export const PRICE_VIEW_ERROR = "PRICE_VIEW_ERROR";
export const PRICE_VIEW_LOADING = "PRICE_VIEW_LOADING";
export const PRICE_VIEW_SUCCESS = "PRICE_VIEW_SUCCESS";

export const PRICE_ADD_ERROR = "PRICE_ADD_ERROR";
export const PRICE_ADD_LOADING = "PRICE_ADD_LOADING";
export const PRICE_ADD_SUCCESS = "PRICE_ADD_SUCCESS";

export const PRICE_DELETE_ERROR = "PRICE_DELETE_ERROR";
export const PRICE_DELETE_LOADING = "PRICE_DELETE_LOADING";
export const PRICE_DELETE_SUCCESS = "PRICE_DELETE_SUCCESS";

// Biaya Pengurusan
export const BIAYAPENGURUSAN_URL = "biaya_pengurusan";

export const BIAYAPENGURUSAN_GET_ERROR = "BIAYAPENGURUSAN_HAS_ERROR";
export const BIAYAPENGURUSAN_GET_LOADING = "BIAYAPENGURUSAN_IS_LOADING";
export const BIAYAPENGURUSAN_GET_SUCCESS = "BIAYAPENGURUSAN_IS_SUCCESS";

export const BIAYAPENGURUSAN_VIEW_ERROR = "BIAYAPENGURUSAN_VIEW_ERROR";
export const BIAYAPENGURUSAN_VIEW_LOADING = "BIAYAPENGURUSAN_VIEW_LOADING";
export const BIAYAPENGURUSAN_VIEW_SUCCESS = "BIAYAPENGURUSAN_VIEW_SUCCESS";

export const BIAYAPENGURUSAN_ADD_ERROR = "BIAYAPENGURUSAN_ADD_ERROR";
export const BIAYAPENGURUSAN_ADD_LOADING = "BIAYAPENGURUSAN_ADD_LOADING";
export const BIAYAPENGURUSAN_ADD_SUCCESS = "BIAYAPENGURUSAN_ADD_SUCCESS";

export const BIAYAPENGURUSAN_DELETE_ERROR = "BIAYAPENGURUSAN_DELETE_ERROR";
export const BIAYAPENGURUSAN_DELETE_LOADING = "BIAYAPENGURUSAN_DELETE_LOADING";
export const BIAYAPENGURUSAN_DELETE_SUCCESS = "BIAYAPENGURUSAN_DELETE_SUCCESS";

// ROLE
export const ROLE_URL = "usery";

export const ROLE_GET_ERROR = "ROLE_HAS_ERROR";
export const ROLE_GET_LOADING = "ROLE_IS_LOADING";
export const ROLE_GET_SUCCESS = "ROLE_IS_SUCCESS";

export const ROLE_VIEW_ERROR = "ROLE_VIEW_ERROR";
export const ROLE_VIEW_LOADING = "ROLE_VIEW_LOADING";
export const ROLE_VIEW_SUCCESS = "ROLE_VIEW_SUCCESS";

export const ROLE_ADD_ERROR = "ROLE_ADD_ERROR";
export const ROLE_ADD_LOADING = "ROLE_ADD_LOADING";
export const ROLE_ADD_SUCCESS = "ROLE_ADD_SUCCESS";

export const ROLE_DELETE_ERROR = "ROLE_DELETE_ERROR";
export const ROLE_DELETE_LOADING = "ROLE_DELETE_LOADING";
export const ROLE_DELETE_SUCCESS = "ROLE_DELETE_SUCCESS";

export const ROLE_EDIT_ERROR = "ROLE_EDIT_ERROR";
export const ROLE_EDIT_LOADING = "ROLE_EDIT_LOADING";
export const ROLE_EDIT_SUCCESS = "ROLE_EDIT_SUCCESS";

// ACL
export const ACL_URL = "acl";

export const ACL_GET_ACTION_ERROR = "ACL_GET_ACTION_HAS_ERROR";
export const ACL_GET_ACTION_LOADING = "ACL_GET_ACTION_IS_LOADING";
export const ACL_GET_ACTION_SUCCESS = "ACL_GET_ACTION_IS_SUCCESS";

export const ACL_SET_ERROR = "ACL_SET_ERROR";
export const ACL_SET_LOADING = "ACL_SET_LOADING";
export const ACL_SET_SUCCESS = "ACL_SET_SUCCESS";

// Priceconsignee
export const PRICECONSIGNEE_URL = "priceconsignee";

export const PRICECONSIGNEE_GET_ERROR = "PRICECONSIGNEE_HAS_ERROR";
export const PRICECONSIGNEE_GET_LOADING = "PRICECONSIGNEE_IS_LOADING";
export const PRICECONSIGNEE_GET_SUCCESS = "PRICECONSIGNEE_IS_SUCCESS";

export const PRICECONSIGNEE_VIEW_ERROR = "PRICECONSIGNEE_VIEW_ERROR";
export const PRICECONSIGNEE_VIEW_LOADING = "PRICECONSIGNEE_VIEW_LOADING";
export const PRICECONSIGNEE_VIEW_SUCCESS = "PRICECONSIGNEE_VIEW_SUCCESS";

export const PRICECONSIGNEE_ADD_ERROR = "PRICECONSIGNEE_ADD_ERROR";
export const PRICECONSIGNEE_ADD_LOADING = "PRICECONSIGNEE_ADD_LOADING";
export const PRICECONSIGNEE_ADD_SUCCESS = "PRICECONSIGNEE_ADD_SUCCESS";

// Acitvity
export const ACTIVITY_URL = "activity";

export const ACTIVITY_GET_ERROR = "ACTIVITY_HAS_ERROR";
export const ACTIVITY_GET_LOADING = "ACTIVITY_IS_LOADING";
export const ACTIVITY_GET_SUCCESS = "ACTIVITY_IS_SUCCESS";

export const ACTIVITY_VIEW_ERROR = "ACTIVITY_VIEW_ERROR";
export const ACTIVITY_VIEW_LOADING = "ACTIVITY_VIEW_LOADING";
export const ACTIVITY_VIEW_SUCCESS = "ACTIVITY_VIEW_SUCCESS";

// REPORT
export const REPORT_DATA_USER_URL = "users/export_pdf";
export const REPORT_JUMLAH_USER_URL = "users/report_jumlah_user";
export const REPORT_WAKTU_TEMPUH_URL = "jadwal/report_waktu_tempuh";
export const REPORT_SISA_KUOTA_URL = "typecontainer/report_sisa_kuota";
export const REPORT_DISPARITAS_HARGA_URL = "commodity/report_disparitas_harga";
export const REPORT_CONTAINER_PER_PORT_URL =
  "pelabuhan/report_container_per_port";
export const REPORT_MUATAN_PER_WILAYAH_URL =
  "pelabuhan/report_muatan_per_wilayah";
export const REPORT_ORDER_MASUK_PER_BULAN_URL =
  "trayek/report_order_masuk_per_bulan";
export const REPORT_ORDER_PER_JENIS_PRIORITAS_URL =
  "jenis_barang/report_order_per_jenis_prioritas";
export const REPORT_REALISASI_MUATAN_PER_OPERATOR_URL =
  "jadwal/report_realisasi_muatan_per_operator";
export const REPORT_REALISASI_VOYAGE_PER_TRAYEK_URL =
  "master_trayek/report_realisasi_voyage_per_trayek";
export const REPORT_MUATAN_PER_WILAYAH_PER_PRIORITAS_URL =
  "pelabuhan/report_muatan_per_wilayah_per_prioritas";
export const REPORT_JENIS_MUATAN_TERBANYAK_PER_PRIORITAS_URL =
  "detailcontainer/report_jenis_muatan_terbanyak_per_prioritas";
export const REPORT_TOTAL_ORDER_URL = "dashboard/report_total_order";

// Module new
export const STATUS_SISA_KUOTA = "STATUS_SISA_KUOTA";
export const EMPTY_CONTAINER = "EMPTY_CONTAINER";

// master_kapal
export const KAPAL_URL = "master_kapal";
export const LIST_OPERATOR_URL = "list_operator";
export const KAPAL_GET_SUCCESS = "KAPAL_IS_SUCCESS";
export const KAPAL_GET_MODAL = "KAPAL_GET_MODAL";
export const KAPAL_EDIT = "KAPAL_EDIT";
export const LIST_OP_GET_SUCCESS = "LIST_OP_GET_SUCCESS";
export const ADD_MASTER_GET_SUCCESS = "ADD_MASTER_GET_SUCCESS";
export const DELL_MASTER_GET_SUCCESS = "DELL_MASTER_GET_SUCCESS";
export const KAPAL_GET_DELL_MODAL = "KAPAL_GET_DELL_MODAL";
export const MASTER_KAPAL_OPERATOR_URL = "master_kapal_operator";
export const MASTER_KAPAL_OPERATOR = "MASTER_KAPAL_OPERATOR";

// master_kontrak
export const KONTRAK_URL = "master_kontrak";
export const KONTRAK_GET_SUCCESS = "KONTRAK_GET_SUCCESS";
export const KONTRAK_GET_MODAL = "KONTRAK_GET_MODAL";
export const TRAYEK_URL = "master_kode_trayek";
export const LIST_TRAYEK_GET_SUCCESS = "LIST_TRAYEK_GET_SUCCESS";
export const ADD_KONTRAK_GET_SUCCESS = "ADD_KONTRAK_GET_SUCCESS";
export const KONTRAK_EDIT = "KONTRAK_EDIT";
export const KONTRAK_DELETE = "KONTRAK_DELETE";
export const ADENDUM = "ADENDUM";
export const ADENDUM_GET_SUCCESS = "ADENDUM_GET_SUCCESS";

// report trayek balik
export const MASTER_KODE_TRAYEK_REPORT_URL = "master_kode_trayek";
export const TRAYEK_BALIK_URL = "trayek_balik/";
export const YEAR_MASTER_KODE_TRAYEK = "YEAR_MASTER_KODE_TRAYEK";
export const MASTER_DATA_TRAYEK_BALIK = "MASTER_DATA_TRAYEK_BALIK";
export const SHOW_TABLE_DETAIL_TRAYEK_BALIK = "SHOW_TABLE_DETAIL_TRAYEK_BALIK";
export const MASTER_DATA_DETAIL_TRAYEK_BALIK =
  "MASTER_DATA_DETAIL_TRAYEK_BALIK";
export const KODE_TRAYEK_MASTER_BALIK = "KODE_TRAYEK_MASTER_BALIK";
export const MASTER_DATA_BARANG_PERUAS = "MASTER_DATA_BARANG_PERUAS";
export const MODAL_BARANG_PERUAS = "MODAL_BARANG_PERUAS";
export const MASTER_DATA_CONSIGNE = "MASTER_DATA_CONSIGNE";
export const MASTER_DATA_PELABUHAN = "MASTER_DATA_PELABUHAN";

// maintenance
export const MAINTENANCE_MODAL = "MAINTENANCE_MODAL";
export const MAINTENANCE_GET_SUCCESS = "MAINTENANCE_GET_SUCCESS";
export const ADD_MAINTENANCE_GET_SUCCESS = "ADD_MAINTENANCE_GET_SUCCESS";
export const DELETE_MAINTENANCE_GET_SUCCESS = "DELETE_MAINTENANCE_GET_SUCCESS";
export const EDIT_MAINTENANCE_GET_SUCCESS = "EDIT_MAINTENANCE_GET_SUCCESS";
export const MAINTENANCE_MODAL_PAGE = "MAINTENANCE_MODAL_PAGE";

// booking_view role shipper
export const LIST_PAY_SUCCESS = "LIST_PAY_SUCCESS";
export const PAY_CHANEL_SUCCESS = "PAY_CHANEL_SUCCESS";

// guest
export const GUEST_FETCH_ALL = "GUEST_FETCH_ALL";

// Handle Status Consignee
export const HANDLE_STATUS_LOADING = "HANDLE_STATUS_LOADING";
export const HANDLE_STATUS_SUCCESS = "HANDLE_STATUS_SUCCESS";
export const HANDLE_STATUS_ERROR = "HANDLE_STATUS_ERROR";

// Handle Approve Document Consignee
export const HANDLE_APPROVE_DOC_LOADING = "HANDLE_APPROVE_DOC_LOADING";
export const HANDLE_APPROVE_DOC_SUCCESS = "HANDLE_APPROVE_DOC_SUCCESS";
export const HANDLE_APPROVE_DOC_ERROR = "HANDLE_APPROVE_DOC_ERROR";
